import { readFileSync } from 'fs';
import { join } from 'path';

// Reads a file written by tools/content/build-content.mjs, which runs before every serve and build.
export function loadContentFileFs(environment: string, relativePath: string): string {
  const filePath = join(
    process.cwd(),
    'tmp/content',
    environment,
    'data',
    relativePath
  );

  return readFileSync(filePath, 'utf-8');
}

export function hasBlogPostsFs(environment: string): boolean {
  return JSON.parse(loadContentFileFs(environment, 'site.json')).hasBlog;
}
